import customFormData from "./custom-form-data";

const { general, clock, spots, scoring } = customFormData;

const cflCustomFormData = {
    general: {
        ...general,
        includeEndZoneYardage: {
            ...general.includeEndZoneYardage,
            icon: "canadian-flag"
        },
        collectStatsOnPat: {
            ...general.collectStatsOnPat,
            icon: "canadian-flag"
        },
        touchdownsCountAsFirstDowns: {
            ...general.touchdownsCountAsFirstDowns,
            icon: "canadian-flag"
        },
        downs: {
            ...general.downs,
            icon: "canadian-flag"
        },
        fieldLength: {
            ...general.fieldLength,
            icon: "canadian-flag"
        },
        fieldWidth: {
            ...general.fieldWidth,
            icon: "canadian-flag"
        },
        minutesByPeriod: {
            ...general.minutesByPeriod,
            icon: "canadian-flag"
        },
        timeoutsPerHalf: {
            ...general.timeoutsPerHalf,
            icon: "canadian-flag"
        },
        teamLossOnly: {
            ...general.teamLossOnly,
            icon: "canadian-flag"
        },
        promptToSkipKickoff: {
            ...general.promptToSkipKickoff,
            icon: "canadian-flag"
        }
    },
    clock: {
        ...clock,
        clockType: {
            ...clock.clockType,
            icon: "canadian-flag"
        }
    },
    spots: {
        ...spots,
        rougeYardline: {
            ...spots.rougeYardline,
            icon: "canadian-flag"
        },
        kickoff: {
            ...spots.kickoff,
            icon: "canadian-flag"
        },
        KOTouchback: {
            ...spots.KOTouchback,
            icon: "canadian-flag"
        },
        PATTry: {
            ...spots.PATTry,
            icon: "canadian-flag"
        },
        safetyKO: {
            ...spots.safetyKO,
            icon: "canadian-flag"
        },
        driveStartingYardline: {
            ...spots.driveStartingYardline,
            icon: "canadian-flag"
        },
        touchbackYardline: {
            ...spots.touchbackYardline,
            icon: "canadian-flag"
        },
        overtimeStartingYardline: {
            ...spots.overtimeStartingYardline,
            icon: "canadian-flag"
        },
        goalPostLocation: {
            ...spots.goalPostLocation,
            icon: "canadian-flag"
        }
    },
    scoring: {
        ...scoring,
        rougePoints: {
            ...scoring.rougePoints,
            icon: "canadian-flag"
        }
    }
};

export default cflCustomFormData;
